import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router';
import {
  CLOSE_BUTTON_LABEL,
  HOMEPAGE_LINK_ALT_TEXT,
} from '../../../assets/copy';
import { ReactComponent as Logo } from '../../../assets/icons/logo.svg';
import { trackClick } from '../../../utils/useOneTag';
import clsx from 'clsx';
import { focusVisible } from '../../../utils/ada/contrastStyles';
import CloseButton from '../../core/CloseButton';
import palette from '../../../theme/palette';
import MarketSelector from '../MarketSelector';

const useStyles = makeStyles((theme) => ({
  root: {},
  header: {
    width: '100%',
    height: ({ variant }) => (variant === 'compact' ? 54 : 96),
    backgroundColor: theme.palette.background.white,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: theme.breakpoints.values.xxl,
    margin: '0 auto',
    padding: theme.spacing(0, 1),
    height: '100%',
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(3),
      padding: theme.spacing(0, 3),
    },
  },
  logoButton: {
    ...focusVisible(),
    boxSizing: 'border-box',
    padding: theme.spacing(1),
    borderRadius: 2,
  },
  logo: { width: 105, minWidth: 105 },
  section: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  navLinkGap: {
    gap: theme.spacing(4),
  },
}));

/**
 * Main app navigation bar
 *
 * @param {object} props
 * @param {object} [props.classes] Overrides or extends default styles
 * @param {'default'|'compact'} [props.variant] The variant of the navigation bar
 * @param {function} [props.onClose] Replaces menu and search buttons with a close button that triggers this callback
 * @returns {JSX.Element}
 */
export const NavBarClose = ({
  classes: classesOverride,
  variant = 'default',
  onClose,
}) => {
  const classes = useStyles({ classes: classesOverride, variant });
  const history = useHistory();

  const handleClick = (event) => {
    trackClick(event, 'app-bar-logo', 'Link');
    history.push('/');
  };

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <div className={classes.container}>
          <div className={clsx(classes.section, classes.navLinkGap)}>
            <Button
              disableRipple
              className={classes.logoButton}
              onClick={handleClick}
              data-cy="app-bar-logo"
              aria-label={HOMEPAGE_LINK_ALT_TEXT}>
              <Logo className={classes.logo} />
            </Button>
          </div>

          <div className={classes.section}>
            <MarketSelector />

            <CloseButton
              autoFocus
              height={16}
              width={16}
              fill={palette.spoon.black[100]}
              label={CLOSE_BUTTON_LABEL}
              close={onClose}
            />
          </div>
        </div>
      </header>
    </div>
  );
};

export default NavBarClose;
